import template from './EditPanelOverlay.html';

/* @ngInject */
function EditPanelOverlayController(DashboardService, EquipmentInfoService) {
  const vm = this;

  /**
   * Public Variables
   */
  vm.loadingSpinners = {
    stopEditPanelOverlay: true
  };
  vm.confirmDelete = {
    showConfirm: false
  };
  // store reference to equipmentAsObject in the equipmentModel
  vm.equipmentAsObject = EquipmentInfoService.model.byId;

  /**
   * Public Methods
   */
  vm.$onInit = init;
  vm.confirmRemovePanel = confirmRemovePanel;
  vm.cancelDelete = cancelDelete;
  vm.removeEditPanel = removeEditPanel;
  vm.editPanel = editPanel;

  function init() {
    vm.panId = vm.thisPanel.id;
    vm.currentDashboard = DashboardService.getCurrentDashboard();
    vm.panels = vm.currentDashboard.panels;
  }

  function confirmRemovePanel() {
    vm.confirmDelete.showConfirm = true;
  }

  function cancelDelete() {
    vm.confirmDelete.showConfirm = false;
  }

  function removeEditPanel(panelId) {
    vm.confirmDelete.showConfirm = false;
    DashboardService.removePanelFromDashboard(panelId);
  }

  function editPanel() {
    DashboardService.openEditPanelModal(vm.thisPanel.id)
      .then((panels) => {
        _.forEach(panels, (panObj) => {
          vm.panels[panObj.id].equipment = panObj.equipment;
        });
      });
  }
}

export default {
  name: 'editPanel',
  template,
  controller: EditPanelOverlayController,
  controllerAs: 'EditPanelOverlayCtrl',
  bindings: {
    thisPanel: '<'
  },
  transclude: true
};
